import { axiosInstance } from '@/http-common'

export * from './getters'

/**
 * Get asset images
 * @param id - Asset ID
 * @param source
 */
export async function getAssetImages(id: number | string, source?: 'device'): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/asset/${id}/images`, {
      params: source ? { source } : undefined
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Add asset image
 * @param id - Asset ID
 * @param formData - FormData with image file
 * @param source
 */
export async function addAssetImage(id: number | string, formData: FormData, source?: 'device'): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`/api/v1/asset/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: source ? { source } : undefined
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Delete asset image
 * @param id - Asset ID
 * @param imageId - Image ID
 * @param source
 */
export async function deleteAssetImage(id: number | string, imageId: number | string, source?: 'device'): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.delete(`/api/v1/asset/${id}/images/${imageId}`, {
      params: source ? { source } : undefined
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Update asset name
 * @param id - Asset ID
 * @param name - Asset name
 * @param source
 */
export async function updateAssetName(id: number | string, name: string, source?: 'device'): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset/${id}`, { name }, {
      params: source ? { source } : undefined
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Update default location for an asset
 * @param id - Asset ID
 * @param data - Default location data (defaultLatitude, defaultLongitude)
 */
export async function updateAssetDefaultLocation(id: number | string, data: any): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.patch(`/api/v1/asset/${id}/default-location`, data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
